"use strict";
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-carbon
 * (C) Copyright IBM Corp. 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const NumberInput_1 = tslib_1.__importStar(require("carbon-components-react/es/components/NumberInput/NumberInput"));
const StringResource_1 = require("../nls/StringResource");
const settings_1 = tslib_1.__importDefault(require("../settings"));
const { prefix } = settings_1.default;
const CLASS = `${prefix}-numberInput-component`;
const DECREMENT = StringResource_1.stringResource.get('numberInputDecrement');
const INCREMENT = StringResource_1.stringResource.get('numberInputIncrement');
const CarbonNumberInputTranslationIds = (NumberInput_1.translationIds !== null && NumberInput_1.translationIds !== void 0 ? NumberInput_1.translationIds : {
    'increment.number': 'increment.number',
    'decrement.number': 'decrement.number',
});
const TRANSLATE_WITH_ID = {
    [CarbonNumberInputTranslationIds['decrement.number']]: DECREMENT,
    [CarbonNumberInputTranslationIds['increment.number']]: INCREMENT,
};
const NumberInput = react_1.default.forwardRef((props, ref) => {
    const { 
    // remove - remapped
    'data-tid': dataTid, translateWithId } = props, 
    // pass all other props to Carbon Button
    otherNumberInputProps = tslib_1.__rest(props, ['data-tid', "translateWithId"]);
    const mappedDataTid = (dataTid !== null && dataTid !== void 0 ? dataTid : CLASS);
    const mappedTranslateWithId = (translateWithId !== null && translateWithId !== void 0 ? translateWithId : ((id) => TRANSLATE_WITH_ID[id]));
    return (react_1.default.createElement(NumberInput_1.default, Object.assign({ "data-tid": mappedDataTid, ref: ref, translateWithId: mappedTranslateWithId }, otherNumberInputProps)));
});
NumberInput.propTypes = NumberInput_1.default.propTypes;
NumberInput.defaultProps = NumberInput_1.default.defaultProps;
exports.default = NumberInput;
exports.translationIds = CarbonNumberInputTranslationIds;
